import React, { Component } from "react";
import { Collapse } from "reactstrap";
import moment from "moment";
import { Icon } from "antd";
import "../../styles/components/Home/Schedule.css";
import TimeLine from "../../features/ChangeLog/index";
import { Tabs } from "antd";
import { getAllEvents } from "../../features/ChangeLog/data";
import "moment/locale/sq";
const TabPane = Tabs.TabPane;

function callback(key) {
  console.log(key);
}
moment.locale(localStorage.getItem("language") === "en" ? "en" : "sq");
class Schedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: {},
      seancaDate: moment().set({ h: 0, m: 0 }),
      komisioneDate: moment().set({ h: 0, m: 0 }),
      seancaEvents: [],
      komisioneEvents: []
    };
  }
  componentWillMount = () => {
    getAllEvents(this.state.seancaDate).then(response => {
      this.setState({ seancaEvents: filterEvents(response, true) });
    });
    getAllEvents(this.state.komisioneDate).then(response => {
      this.setState({ komisioneEvents: filterEvents(response, false) });
    });
  };
  toggleCollapse = index => {
    let collapse = this.state.collapse;
    collapse[index] = !collapse[index];
    this.setState({ collapse });
  };
  returnCollapse = (info, index) => {
    return (
      <>
        <Collapse isOpen={this.state.collapse[index]}>{info}</Collapse>
      </>
    );
  };
  changeSeanca = plus => {
    let seancaDate;
    if (plus) {
      seancaDate = this.state.seancaDate.add(1, "days");
    } else {
      seancaDate = this.state.seancaDate.subtract(1, "days");
    }

    getAllEvents(seancaDate).then(response => {
      this.setState({ seancaEvents: filterEvents(response, true), seancaDate });
    });
  };
  changeKomision = plus => {
    let komisioneDate;
    if (plus) {
      komisioneDate = this.state.komisioneDate.add(1, "days");
    } else {
      komisioneDate = this.state.komisioneDate.subtract(1, "days");
    }

    getAllEvents(komisioneDate).then(response => {
      this.setState({
        komisioneEvents: filterEvents(response, false),
        komisioneDate
      });
    });
  };
  render() {
    console.log("StateChange", this.state);
    return (
      <div className="Schedule">
        <h2 className="schedule-title">Rendi i dites</h2>
        <Tabs defaultActiveKey="1" onChange={callback}>
          <TabPane tab="Seanca Plenare" key="1" className="seanca-planare">
            <div className="select-cont">
              <div className="date-select">
                <div className="day-icon">
                  <Icon
                    onClick={() => {
                      this.changeSeanca(false);
                    }}
                    type="left-circle"
                  />
                </div>
                <div className="date">{this.state.seancaDate.format("LL")}</div>
                <div className="day-icon">
                  <Icon
                    onClick={() => {
                      this.changeSeanca(true);
                    }}
                    type="right-circle"
                  />
                </div>
              </div>
              <div className="steps-cont">
                <TimeLine isSeance={true} events={this.state.seancaEvents} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="Komisione" key="2">
            <div className="select-cont">
              <div className="date-select">
                <div className="day-icon">
                  <Icon
                    onClick={() => {
                      this.changeKomision(false);
                    }}
                    type="left-circle"
                  />
                </div>
                <div className="date">
                  {this.state.komisioneDate.format("LL")}
                </div>
                <div className="day-icon">
                  <Icon
                    onClick={() => {
                      this.changeKomision(true);
                    }}
                    type="right-circle"
                  />
                </div>
              </div>
              <div className="steps-cont">
                <TimeLine
                  isSeance={false}
                  events={this.state.komisioneEvents}
                />
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    );
  }
}
const filterEvents = (events, seanca) => {
  let newEvents = [];
  events.map(event => {
    if (seanca) {
      if (event.Struktura.Emri === "Seanca Plenare") {
        newEvents.push(event);
      }
    } else {
      if (event.Struktura.Emri !== "Seanca Plenare") {
        newEvents.push(event);
      }
    }
    return true;
  });
  return newEvents;
};

export default Schedule;
